export var DragAndDropOperationNames;
(function (DragAndDropOperationNames) {
    DragAndDropOperationNames["ASSIGN_OBJECT_TO_LESSON"] = "assignObjectToLesson";
    DragAndDropOperationNames["DELETE_LESSON"] = "deleteLesson";
    DragAndDropOperationNames["PLAN_COURSE"] = "planCourse";
    DragAndDropOperationNames["UPLOAD_FILE"] = "uploadFile";
    DragAndDropOperationNames["COPY_CONTENT_OF_LESSON"] = "copyContentOfLesson";
})(DragAndDropOperationNames || (DragAndDropOperationNames = {}));
export var DroppableIds;
(function (DroppableIds) {
    DroppableIds["DELETE_LESSON"] = "delete-lesson";
})(DroppableIds || (DroppableIds = {}));
